'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _graphql = require('graphql');

var _MarkdownContent = require('./MarkdownContent');

var _MarkdownContent2 = _interopRequireDefault(_MarkdownContent);

var _TypeLink = require('./TypeLink');

var _TypeLink2 = _interopRequireDefault(_TypeLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Copyright (c) 2015, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  This source code is licensed under the license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  LICENSE-examples file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var TypeDoc = function (_React$Component) {
  _inherits(TypeDoc, _React$Component);

  function TypeDoc() {
    _classCallCheck(this, TypeDoc);

    return _possibleConstructorReturn(this, (TypeDoc.__proto__ || Object.getPrototypeOf(TypeDoc)).apply(this, arguments));
  }

  _createClass(TypeDoc, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.type !== nextProps.type || this.props.schema !== nextProps.schema;
    }
  }, {
    key: 'render',
    value: function render() {
      var schema = this.props.schema;
      var type = this.props.type;
      var onClickType = this.props.onClickType;
      var onClickField = this.props.onClickField;

      var typesTitle = void 0;
      var types = void 0;
      if (type instanceof _graphql.GraphQLUnionType) {
        typesTitle = 'possible types';
        types = schema.getPossibleTypes(type);
      } else if (type instanceof _graphql.GraphQLInterfaceType) {
        typesTitle = 'implementations';
        types = schema.getPossibleTypes(type);
      } else if (type instanceof _graphql.GraphQLObjectType) {
        typesTitle = 'implements';
        types = type.getInterfaces();
      }

      var typesDef = void 0;
      if (types && types.length > 0) {
        typesDef = _react2.default.createElement(
          'div',
          { className: 'doc-category' },
          _react2.default.createElement(
            'div',
            { className: 'doc-category-title' },
            typesTitle
          ),
          types.map(function (subtype) {
            return _react2.default.createElement(
              'div',
              { key: subtype.name, className: 'doc-category-item' },
              _react2.default.createElement(_TypeLink2.default, { type: subtype, onClick: onClickType })
            );
          })
        );
      }

      // InputObject and Object
      var fieldsDef = void 0;
      if (type.getFields) {
        (function () {
          var fieldMap = type.getFields();
          var fields = Object.keys(fieldMap).map(function (name) {
            return fieldMap[name];
          });
          fieldsDef = _react2.default.createElement(
            'div',
            { className: 'doc-category' },
            _react2.default.createElement(
              'div',
              { className: 'doc-category-title' },
              'fields'
            ),
            fields.map(function (field) {

              // Field arguments
              var argsDef = void 0;
              if (field.args && field.args.length > 0) {
                argsDef = field.args.map(function (arg) {
                  return _react2.default.createElement(
                    'span',
                    { className: 'arg', key: arg.name },
                    _react2.default.createElement(
                      'span',
                      { className: 'arg-name' },
                      arg.name
                    ),
                    ': ',
                    _react2.default.createElement(_TypeLink2.default, { type: arg.type, onClick: onClickType })
                  );
                });
              }

              return _react2.default.createElement(
                'div',
                { key: field.name, className: 'doc-category-item' },
                _react2.default.createElement(
                  'a',
                  {
                    className: 'field-name',
                    onClick: function onClick(event) {
                      return onClickField(field, type, event);
                    } },
                  field.name
                ),
                argsDef && ['(', _react2.default.createElement(
                  'span',
                  { key: 'args' },
                  argsDef
                ), ')'],
                ': ',
                _react2.default.createElement(_TypeLink2.default, { type: field.type, onClick: onClickType }),
                (field.isDeprecated || field.deprecationReason) && _react2.default.createElement(
                  'span',
                  { className: 'doc-alert-text' },
                  ' (DEPRECATED)'
                )
              );
            })
          );
        })();
      }

      var valuesDef = void 0;
      if (type instanceof _graphql.GraphQLEnumType) {
        valuesDef = _react2.default.createElement(
          'div',
          { className: 'doc-category' },
          _react2.default.createElement(
            'div',
            { className: 'doc-category-title' },
            'values'
          ),
          type.getValues().map(function (value) {
            return _react2.default.createElement(
              'div',
              { key: value.name, className: 'doc-category-item' },
              _react2.default.createElement(
                'div',
                { className: 'enum-value' },
                value.name,
                (value.isDeprecated || value.deprecationReason) && _react2.default.createElement(
                  'span',
                  { className: 'doc-alert-text' },
                  ' (DEPRECATED)'
                )
              ),
              _react2.default.createElement(_MarkdownContent2.default, {
                className: 'doc-value-description',
                markdown: value.description
              }),
              value.deprecationReason && _react2.default.createElement(_MarkdownContent2.default, {
                className: 'doc-alert-text',
                markdown: value.deprecationReason
              })
            );
          })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_MarkdownContent2.default, {
          className: 'doc-type-description',
          markdown: type.description || 'No Description'
        }),
        type instanceof _graphql.GraphQLObjectType && typesDef,
        fieldsDef,
        valuesDef,
        !(type instanceof _graphql.GraphQLObjectType) && typesDef
      );
    }
  }]);

  return TypeDoc;
}(_react2.default.Component);

TypeDoc.propTypes = {
  schema: _react.PropTypes.instanceOf(_graphql.GraphQLSchema),
  type: _react.PropTypes.object,
  onClickType: _react.PropTypes.func,
  onClickField: _react.PropTypes.func
};
exports.default = TypeDoc;


//////////////////
// WEBPACK FOOTER
// ./~/graphiql/dist/components/DocExplorer/TypeDoc.js
// module id = ./node_modules/graphiql/dist/components/DocExplorer/TypeDoc.js
// module chunks = 0